import {
  CloseIcon,
  UndoIcon,
  ErrorOutlinedIcon,
  CheckmarkCircleIcon,
  InfoOutlinedIcon,
} from '../../assets/svg';
import { Title } from './styled';
import { Box, makeStyles, Button } from '@material-ui/core';
import React from 'react';

const toastColorStyle = makeStyles((theme) => ({
  error: {
    color: theme.palette.feedback.error,
  },
  success: {
    color: theme.palette.feedback.success,
  },
  info: {
    color: theme.palette.secondary.main,
  },
}));

const renderIcon = (type, className, isAction = false) => {
  let Icon;
  switch (type) {
    case 'error':
      Icon = ErrorOutlinedIcon;
      break;
    case 'success':
      Icon = CheckmarkCircleIcon;
      break;
    case 'info':
      Icon = isAction ? UndoIcon : InfoOutlinedIcon;
      break;

    default:
      Icon = null;
  }
  return <Icon className={className} style={{ marginRight: 8 }} />;
};

const CustomNotificationContent = ({
  type,
  title,
  description,
  isAction,
  labelBtn = 'View',
  isClose = true,
  onClick,
}) => {
  const classes = toastColorStyle();
  return (
    <Box display="flex" justifyContent="space-between">
      {title ? (
        <>
          <Box display="flex" style={{ color: '#333333' }}>
            {renderIcon(type, classes[type], isAction)}
            <div>
              <Title className={classes[type]}>{title}</Title>
              {description}
            </div>
          </Box>
          {isAction ? (
            <Button
              onClick={onClick}
              variant="text"
              color="primary"
              style={{
                minWidth: 50,
                fontSize: 14,
                alignSelf: 'center',
              }}
            >
              {labelBtn}
            </Button>
          ) : (
            <CloseIcon className="close" />
          )}
        </>
      ) : (
        <>
          <Box display="flex" alignItems="center" className={classes[type]}>
            {renderIcon(type, classes[type])}
            {description}
          </Box>
          {isClose && <CloseIcon className="close" />}
        </>
      )}
    </Box>
  );
};

export default CustomNotificationContent;
